// HowRespiteCareWorksSection.js
import React from "react";
import { Phone } from "lucide-react";
import howRespiteCareWorksImage from "../assets/how-respite-care-works-image.jpg";

const HowRespiteCareWorksSection = () => {
  const services = [
    "Follow a personalised care plan, delivered by a caregiver carefully matched to your loved one's needs and personality",
    "Help prevent caregiver burnout and reduce the emotional strain of providing constant care",
    "Support your well-being, so you can continue caring with energy, patience, and peace of mind",
    "Give you time to rest, recharge, and return to caregiving feeling renewed",
  ];

  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Image */}
          <div>
            <img
              src={howRespiteCareWorksImage}
              alt="Smiling elderly man"
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>

          {/* Right Content */}
          <div>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
              How Respite Care Works
            </h3>

            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-6">
              <p>
                When you reach out to Allawah Lodge, one of our respite care
                professionals will schedule a complimentary in-home assessment
                to better understand your needs and those of your loved one. Our
                flexible, experienced caregivers are ready to step in—whether
                you need just a few hours of support each week or
                around-the-clock care.
              </p>

              <p className="font-normal">
                Our respite care services are designed to:
              </p>
            </div>

            <ul className="space-y-3 text-gray-700 font-light mb-8">
              {services.map((service, index) => (
                <li key={index} className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>{service}</span>
                </li>
              ))}
            </ul>

            <a
              href="tel:+61269272706"
              className="inline-flex items-center gap-2 bg-[#E85D2C] hover:bg-[#d54d1f] text-white font-medium px-6 py-3 rounded-full transition-colors"
            >
              <Phone size={20} />
              CALL: (02) 6927 2706
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowRespiteCareWorksSection;
